module.exports = __webpack_public_path__ + "static/media/KAMOKEN_screenshot.1dfbf3d9.PNG";